// extracted by mini-css-extract-plugin
export default {"videoCutsBackBtn":"BackButton_videoCutsBackBtn__UWypr"};